/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { LookAtCommand } from "../../../skills/waypoints";
import { TriggerArgs_TimerCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

export interface PublishExecutiveLookAtCommandActionArgs {
  trigger:
    | TriggerArgs_TimerCallback
    | undefined;
  /** The LookAtCommand that should be published when the timer triggers */
  lookAtCommand: LookAtCommand | undefined;
}

function createBasePublishExecutiveLookAtCommandActionArgs(): PublishExecutiveLookAtCommandActionArgs {
  return { trigger: undefined, lookAtCommand: undefined };
}

export const PublishExecutiveLookAtCommandActionArgs = {
  encode(message: PublishExecutiveLookAtCommandActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_TimerCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.lookAtCommand !== undefined) {
      LookAtCommand.encode(message.lookAtCommand, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PublishExecutiveLookAtCommandActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePublishExecutiveLookAtCommandActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_TimerCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.lookAtCommand = LookAtCommand.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PublishExecutiveLookAtCommandActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_TimerCallback.fromJSON(object.trigger) : undefined,
      lookAtCommand: isSet(object.lookAtCommand) ? LookAtCommand.fromJSON(object.lookAtCommand) : undefined,
    };
  },

  toJSON(message: PublishExecutiveLookAtCommandActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_TimerCallback.toJSON(message.trigger);
    }
    if (message.lookAtCommand !== undefined) {
      obj.lookAtCommand = LookAtCommand.toJSON(message.lookAtCommand);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PublishExecutiveLookAtCommandActionArgs>, I>>(
    base?: I,
  ): PublishExecutiveLookAtCommandActionArgs {
    return PublishExecutiveLookAtCommandActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PublishExecutiveLookAtCommandActionArgs>, I>>(
    object: I,
  ): PublishExecutiveLookAtCommandActionArgs {
    const message = createBasePublishExecutiveLookAtCommandActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_TimerCallback.fromPartial(object.trigger)
      : undefined;
    message.lookAtCommand = (object.lookAtCommand !== undefined && object.lookAtCommand !== null)
      ? LookAtCommand.fromPartial(object.lookAtCommand)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
